/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lg-container[_ngcontent-%COMP%]{padding:1rem}.phone-number-dropdown[_ngcontent-%COMP%]{width:60%}"];
export { styles as styles };
